import { ArrowLeft, Sparkle, Upload } from "@phosphor-icons/react";

/**
 * Step 3 of CreateSong: cover design.
 * User can upload a photo OR generate a typographic AI cover ("Sin foto").
 */
export const CoverStep = ({
  albumName,
  setAlbumName,
  coverPreview,
  uploading,
  onFile,
  onNoPhoto,
  onBack,
}) => {
  return (
    <div data-testid="step-3">
      <p className="text-sm uppercase tracking-widest text-[#FFB800] mb-2">Paso 3 de 3</p>
      <h1 className="font-display text-3xl sm:text-4xl font-bold mb-2">Diseña tu portada</h1>
      <p className="text-white/60 mb-6">
        Tu canción ya casi está lista. Sube <span className="text-white">tu foto</span> o una imagen
        que te guste (un recuerdo, un paisaje, lo que quieras) — le aplicamos un filtro
        profesional según tu género y queda como portada de disco real.
      </p>

      <div className="mb-6">
        <label className="text-xs uppercase tracking-widest text-white/60 mb-2 block">
          Nombre de tu disco <span className="text-white/30 normal-case">(opcional)</span>
        </label>
        <input
          value={albumName}
          onChange={(e) => setAlbumName(e.target.value.slice(0, 32))}
          placeholder='Ej: "Mis Recuerdos Vol. 1"'
          className="w-full px-4 py-3 rounded-xl bg-[#121212] border border-white/10 focus:border-[#FFB800] focus:outline-none transition-colors placeholder-white/30"
          data-testid="input-album-name"
        />
        <p className="text-[11px] text-white/40 mt-1.5">Aparecerá en tu portada y en el archivo MP3 que descargues.</p>
      </div>

      {coverPreview ? (
        <div className="mb-6">
          <img src={coverPreview} alt="Carátula" className="w-full max-w-sm mx-auto rounded-2xl shadow-2xl" data-testid="cover-preview" />
        </div>
      ) : (
        <>
          <p className="text-xs uppercase tracking-widest text-white/50 mb-3">¿Quieres usar una foto en tu portada?</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-6">
            <label
              htmlFor="photo-input"
              className="block border-2 border-dashed border-white/15 rounded-2xl p-6 text-center cursor-pointer hover:border-[#FFB800] hover:bg-white/5 transition-all"
              data-testid="photo-dropzone"
            >
              <Upload size={32} className="mx-auto text-[#FFB800] mb-2" />
              <p className="font-display font-bold text-base">Con foto</p>
              <p className="text-xs text-white/50 mt-1">JPG/PNG · Máx 8MB</p>
            </label>
            <button
              type="button"
              onClick={onNoPhoto}
              disabled={uploading}
              className="rounded-2xl p-6 bg-gradient-to-br from-[#FFB800]/15 to-[#FF4B00]/10 border-2 border-[#FFB800]/30 hover:border-[#FFB800] hover:bg-[#FFB800]/15 transition-all text-center disabled:opacity-50"
              data-testid="no-photo-btn"
            >
              <Sparkle size={32} weight="fill" className="mx-auto text-[#FFB800] mb-2" />
              <p className="font-display font-bold text-base">Sin foto</p>
              <p className="text-xs text-white/60 mt-1">Tipografía colorida del género</p>
            </button>
          </div>
        </>
      )}
      <input
        id="photo-input"
        type="file"
        accept="image/*"
        onChange={onFile}
        className="hidden"
        data-testid="photo-input"
      />

      <div className="flex gap-3">
        <button
          onClick={onBack}
          className="px-5 py-3 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 font-medium transition-all flex items-center gap-2"
          data-testid="btn-back-to-lyrics"
        >
          <ArrowLeft size={18} /> Volver
        </button>
      </div>
    </div>
  );
};
